import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/pricing/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/user/pricing/dashboard", search, replace: true });
  },
});
